import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { range } from '../../../helpers/commonHelper';

import 'react-loading-skeleton/dist/skeleton.css';

const TableLoader = ({ rows, firstTdWidth }) => (
  <>
    {range(1, rows).map((row) => (
      <tr key={row}>
        <td>
          <Skeleton height={30} width={firstTdWidth} />
        </td>
      </tr>
    ))}
  </>
);

export default TableLoader;
